// extracted by mini-css-extract-plugin
module.exports = {"paddingElement":"styles_paddingElement__3vsck"};